/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopia'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nazwa'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Kwiecień',
    FILTER_MONTH_AUG: 'Sierpień',
    FILTER_MONTH_DEC: 'Grudzień',
    FILTER_MONTH_FEB: 'Luty',
    FILTER_MONTH_JAN: 'Styczeń',
    FILTER_MONTH_JUL: 'Lipiec',
    FILTER_MONTH_JUN: 'Czerwiec',
    FILTER_MONTH_MAR: 'Marzec',
    FILTER_MONTH_MAY: 'Maj',
    FILTER_MONTH_NOV: 'Listopad',
    FILTER_MONTH_OCT: 'Październik',
    FILTER_MONTH_SEP: 'Wrzesień',
    GENERATE_HASHTAG: 'Generowanie hashtagu',
    GENERATE_LINK: 'Wygeneruj link',
    GENERATED_HASHTAG: 'Wygenerowany hashtag',
    GENERATED_LINK: 'Wygenerowany link',
    MONTH: 'Miesiąc',
    NAME: 'Nazwa',
    YEAR: 'Rok'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Brak produktów',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Zmiana kryteriów wyszukiwania'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag skopiowany',
    LINK_COPIED: 'Skopiowany link'
  },
  TOOLTIP: {
    MONTH: 'Miesiąc',
    NAME: 'Nazwa',
    YEAR: 'Rok'
  }
};
